import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [cartLoaded, setCartLoaded] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('elizhv-cart');
    if (saved) {
      const parsed = JSON.parse(saved);
      setCart(Array.isArray(parsed) ? parsed : [parsed]);
    }
    setCartLoaded(true);
  }, []);

  useEffect(() => {
    if (!cartLoaded) return;
    if (cart.length > 0) {
      localStorage.setItem('elizhv-cart', JSON.stringify(cart));
    } else {
      localStorage.removeItem('elizhv-cart');
    }
  }, [cart, cartLoaded]);

  const addToCart = (product, size, quantity = 1) => {
    setCart(prev => {
      const existing = prev.find(item => item.product.id === product.id && item.size === size);
      if (existing) {
        return prev.map(item =>
          item.product.id === product.id && item.size === size
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { product, size, quantity, addedAt: new Date().toISOString() }];
    });
  };

  const removeFromCart = (size) => {
    setCart(prev => prev.filter(item => item.size !== size));
  };

  const updateQuantity = (size, quantity) => {
    const qty = parseInt(quantity);
    if (isNaN(qty) || qty <= 0) return;
    setCart(prev =>
      prev.map(item => item.size === size ? { ...item, quantity: qty } : item)
    );
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('elizhv-cart');
  };

  return (
    <CartContext.Provider value={{ cart, cartLoaded, addToCart, removeFromCart, updateQuantity, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
}
